export enum Language {
  EN = 'en',
  RU = 'ru',
}
